import React from 'react';
import "./css/App.css";
import Sidebar from "../component/Sidebar";
import Content from "./Content";
import GitHubIcon from '@material-ui/icons/GitHub';

function App() {
    return (
        <>
            {/* <div className="under__maintainence">
                <h1>This Site is Under Maintainence</h1>
            </div> */}
            <div className="app">
                <div className="app__glassBlur">
                    <div className="app__glass"></div>
                    <div className="app__content">
                        <Sidebar />
                        <Content />
                    </div>
                </div>
                <div className="github" >
                    <a href="https://github.com/AmanBansal619" target="_blank" rel="noreferrer" className="github_link"><GitHubIcon className="github-icon" /></a>
                </div>

            </div>
        </>
    )
}

export default App
